import React, { useState, useEffect } from "react";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { createOrder, saveAuthorization, validateCupon } from "../../api/paypalApi";
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { putCollaborationStatus } from "../../api/collaborationApi";
import { CartContext } from "../../context/cartContext";
import Spinner from "../../components/Spinner/Spinner";

export default function Checkout({ amount, setShowCollaborationSent }) {

    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
    const [currency, setCurrency] = useState(options.currency);

    const { userToken } = useContext(UserContext);
    const { cart, discountCode, cuponApply, setCart, setShoppingCartCount, setDiscountCode, setCuponApply } = useContext(CartContext);

    const [isLoading, setIsLoading] = useState(false);

    /* const onCurrencyChange = ({ target: { value } }) => {
        setCurrency(value);
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: value,
            },
        });
    } */



    const onCreateOrder = (data, actions) => {

        if (cuponApply === true) {
            return validateCupon({
                cuponBody: { name: discountCode },
                token: userToken,
            }).then((response) => {

                if (response.status === 200) {
                    let newAuxOrder = {}
                    let remainingCoupons =
                        response.message.total_cupons - response.message.used_cupons;
                    const auxOrders = [];
                    cart.forEach((collaboration) => {
                        if (remainingCoupons > 0) {
                            auxOrders.push({ id: collaboration.id, cuponCode: discountCode });
                            remainingCoupons--;
                        } else {
                            auxOrders.push({ id: collaboration.id });
                        }
                    });
                    newAuxOrder = { colaborations: auxOrders }
                    return createOrder({
                        orderBody: newAuxOrder,
                        token: userToken,
                    }).then((response) => {
                        return response.message.id
                    })
                }

            })

        } else {
            let newAuxOrder = {}
            const auxOrders = [];
            cart.forEach((collaboration) => {
                auxOrders.push({ id: collaboration.id });
            });
            newAuxOrder = { colaborations: auxOrders }
            return createOrder({
                orderBody: newAuxOrder,
                token: userToken,
            }).then((response) => {
                return response.message.id
            })
        }
    };


    const onApproveOrder = (data, actions) => {
        setIsLoading(true);
        const auxCart = cart.map(async (collaboration) => {
            return await putCollaborationStatus({ collaborationId: collaboration.id, newStatus: 1, token: userToken }).then((response) => {
            })
        })

        Promise.all(auxCart).then(response => {

            actions.order.authorize().then(function (authorization) {

                var authorizationID = authorization.purchase_units[0]
                    .payments.authorizations[0].id;

                return saveAuthorization({
                    authorizationBody: {
                        orderID: data.orderID,
                        authorizationID: authorizationID
                    }, token: userToken
                }).then((responseAut) => {
                    setCart([]);
                    setCuponApply(false);
                    setDiscountCode('');
                    setIsLoading(false);
                    setShowCollaborationSent(true)
                    setShoppingCartCount(0);
                })

                //simular sin fondos la cuenta
            })


        })
    }

    const buttonStyles = {
        //layout: "vertical",
        layout: "horizontal",
        //color: "gold",
        //color: "silver",
        //color: "white",
        //color: "black",
        color: "blue",
        shape: "rect",
        //label: "paypal",
        //label: "installment",
        tagline: false,
    };
    const label = `Pay ${amount}`;
    const button = {
        label: `Pay ${amount}`,
        style: {
            layout: 'vertical',
            color: 'gold',
            shape: 'rect',
            label: 'pay',
            height: 40,
        },
    };
    return (
        <div className="checkout">
            {isPending ? <p>LOADING...</p> : (
                <div style={{ paddingTop: '10px' }}>
                    {/* <select value={currency} onChange={onCurrencyChange}>
                        <option value="USD">💵 USD</option>
                        <option value="EUR">💶 Euro</option>
                    </select> */}
                    <PayPalButtons
                        style={buttonStyles}
                        createOrder={onCreateOrder}
                        onApprove={(data, actions) => {
                            onApproveOrder(data, actions)
                        }}
                        forceReRender={[amount]}
                        onCancel={(data, actions) => {
                            //console.log("CANCEL", data)
                            //Esto me devuleve el orderID
                        }}
                        onError={(data, actions) => {
                            //console.log("ERROR", data)
                            window.location.href = "/error";
                        }}
                    //label={`Pay ${amount}`}
                    //label={label} 
                    //amount={amount}
                    //currency="USD"
                    //button={button}
                    />
                </div>
            )}
            {(isLoading) && <Spinner />}
        </div>
    );
}